module.exports = __webpack_public_path__ + "static/hayashiya-bff31858660e73afe5063e9b6a0b86b0.jpg";